// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton-module__skeleton--qnBgB","skeleton-loading":"Skeleton-module__skeleton-loading--QI9g2"};